console.log('loaded scripts.js');

const observer = new MutationObserver(function(mutations_list) {
	mutations_list.forEach(function(mutation) {
		mutation.addedNodes.forEach(function(added_node) {
            console.log(added_node);
            if(added_node = "<div data-products-list></div>") {
              console.log('added products list');
              var api = new Yotpo.API(yotpo);
              console.log('yotpo api object:');
              console.log(api);
              api.refreshWidgets();
            }
            observer.disconnect();
		});
	});
});

observer.observe(document.querySelector("div[data-products-container]"), { subtree: false, childList: true });